<!--门店休息设置-->
<template>
  <div class="root-container">
    <el-upload
      class="upload-demo"
      :action="uploadUrl"
      :headers="importHeaders"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :on-error = "handleError"
      :before-upload="beforeUpload"
      :limit="9"
      :file-list="fileList"
      list-type="picture">
      <el-button size="small" type="primary">点击上传(5M以内)</el-button>

    </el-upload>
  </div>
</template>

<style>

</style>

<script>

  import { getToken } from '@/utils/auth'
  import messageUtils from "../../utils/messageUtils";
  import {getStaticData} from "../../api/staticData";
  import commonUtils from "../../utils/commonUtils";

  export default {
    name: 'UploadImg',
    props: {
      picList:Array
    },
    data() {
      return {
        picUrls:[],
        fileList: [],
        importHeaders:"",
        uploadUrl:"http://192.168.0.129:8081/sw-api/upload/uploadImg"
      }
    },
    created(){
      this.initData();

    },
    methods: {

      initData(){


        if (false== commonUtils.isArrayNull(this.picList)){
          let tList = JSON.parse(this.picList);
          this.fileList = [];
          for (let i =0;i< tList.length;++i){
            let tm = {
              name:i,
              url:tList[i],
            }
            this.fileList.push(tm);
          }
        }
        let mytoken = getToken();
        this.importHeaders  = {"Authorization": mytoken}

        getStaticData("").then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          // this.uploadUrl = data.uploadImageUrl;

        })
      },
      handleRemove(file, fileList) {
        console.log("handleRemove",file);
        for (let i =0;i< this.picUrls.length;++i){
          if (file.response.data ==  this.picUrls[i]){
            this.picUrls.splice(i,1);
          }
        }
      },
      handleSuccess(response, file, fileList){

        this.picUrls.push(response.data)
        messageUtils.successMsg(this,"上传成功");
      },
      handleError(err, file, fileList){
        messageUtils.errorMsg(this,"上传失败");
      },
      handlePreview(file) {

      },
      beforeUpload(file){
        if (file.size >= 5*1024 * 1024){
          messageUtils.errorMsg(this,"不能上传超过5M的图片");
          return false;
        }
        return true;


      },


      onGetPicUrls(){
        return this.picUrls;
      }

    },


  }
</script>






// WEBPACK FOOTER //
// src/views/components/UploadImg.vue